import React, { createContext, useState, useContext, useEffect } from "react";
import { auth, db } from "../services/firebase";
import { doc, getDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
const AdminContext = createContext();

export function useAdmin() {
  return useContext(AdminContext);
}
export function AdminProvider({ children }) {
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setLoading(true);
      if (user) {
        const userDocRef = doc(db, "users", user.uid);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists() && userDoc.data().role === "gangstar") {
          setIsAdmin(true);
        } else {
          setIsAdmin(false);
        }
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
        setIsAdmin(false);
      }
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  return (
    <AdminContext.Provider value={{ isAdmin, isAuthenticated }}>
      {!loading && children}
    </AdminContext.Provider>
  );
}
